import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Button from '@src/ui/elements/button/Button';
import DragIcon from '@src/ui/elements/table/DragIcon';
import StatusTip from '@src/ui/elements/table/StatusTip';

import { Item } from './SortableCategoryTable';

interface SortableCategoryItemProps<T> {
  item: T;
  handleEditClick: () => void;
}

export const SortableCategoryItem = <T extends Item>({
  item,
  handleEditClick,
}: SortableCategoryItemProps<T>) => {
  const {
    isDragging,
    // 並び替えのつまみ部分に設定するプロパティ
    setActivatorNodeRef,
    attributes,
    listeners,
    // DOM全体に対して設定するプロパティ
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id: item.id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`relative transition-colors [&:nth-child(2n+1)]:bg-gray-10 ${isDragging ? 'z-10 !bg-primary-50' : ''}`}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      data-testid='sortable-item'
    >
      <div className='flex'>
        <div
          ref={setActivatorNodeRef}
          className={`w-[50px] ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
          {...attributes}
          {...listeners}
        >
          <DragIcon />
        </div>
        <div className='flex w-[100px] items-center px-4'>{item.order}</div>
        <div className='flex w-[calc((100%-280px)*0.7)] items-center truncate px-4'>
          <span className='truncate'>{item.name}</span>
        </div>
        <div className='flex w-[calc((100%-280px)*0.3)] items-center px-4'>
          {item.viewable ? (
            <StatusTip
              label='あり'
              active={true}
            />
          ) : (
            <StatusTip
              label='なし'
              active={false}
            />
          )}
        </div>
        <div className='w-[130px] py-[9px]'>
          <Button
            size='s'
            variant='quaternary'
            outline
            onClick={handleEditClick}
          >
            編集する
          </Button>
        </div>
      </div>
    </div>
  );
};
